import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import SahamDrawer from 'components/SahamDrawer';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/messages';
import judgementAddMessages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import { translate } from 'containers/services/translate';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import { JudgementAddFormDrawerStyle } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/styled-components';
import {
  CorporealDocument,
  ExpertiseState,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { cloneDeep, get, isEmpty } from 'lodash';
import JudgementAddFormFields from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/JudgementAddFormFields';
import ExpertiseForm from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/ExpertiseForm';
import { LISTINGS } from 'containers/data-structure';
import { EMPTY_EXPERTISE } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { VictimType } from 'typings/globalTypes';
import { formattedJudgementAddPronouncing } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/utils';
import { FIELDS_TO_UPDATE } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/constants';
import { shouldValidateJudgementPronouncing } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/form-validation';
import {
  extractVictimIdFromJom,
  formatExpertiseState,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/utils';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { DOCUMENT_TYPES } from 'constants/global';
import { JudgementOnMeritsType } from 'containers/LawyerLegalProceedingsPage/typings';

import { EMPTY_SUPPORT_DOC } from 'containers/LawyerRecapPage/constants';

export interface JudgementAddPronouncingDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  victims: VictimType[];
  vehicules: Vehicule[];
  setJudgementAdd: Function;
  index: number;
  judgementAddExpertises: JudgementADDDocumentType[];
  setJudgementAddExpertises: Function;
  listings: Listings;
  hearingDate?: string;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  judgementAddDocumentsStore?: JudgementADDDocumentType[];
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  judgementOnMerits: JudgementOnMeritsType;
}

const JudgementAddPronouncingDrawer: React.FC<JudgementAddPronouncingDrawerProps> = (
  props,
): JSX.Element => {
  const [canSaveJuddgementDocument, setCanSaveJudgementDocument] = useState<
    boolean
  >(false);
  const [expertises, setExpertises] = useState<ExpertiseState[]>([]);

  useEffect(() => {
    const formattedExpertises = formatExpertiseState(
      get(props.judgementAddExpertises[props.index], 'expertises', []),
    );
    if (isEmpty(formattedExpertises)) {
      setExpertises([cloneDeep(EMPTY_EXPERTISE)] as any);
    } else {
      setExpertises(cloneDeep(formattedExpertises));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.index, props.judgementAddExpertises]);

  useEffect(() => {
    setCanSaveJudgementDocument(
      shouldValidateJudgementPronouncing(
        props.judgementAddExpertises[props.index],
        expertises,
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judgementAddExpertises, expertises, props.index]);

  const handleSetExpertise = (index: number) => (expertise: ExpertiseState) => {
    const expertisesAdd = [...expertises];
    expertisesAdd[index] = expertise;

    setExpertises(expertisesAdd);
  };

  /* istanbul ignore next */
  const handleSetJudgementAddPronouncing = (index: number) => (
    value: JudgementADDDocumentType,
  ) => {
    const documents = [...props.judgementAddExpertises];
    documents[index] = value;
    props.setJudgementAddExpertises(documents);
  };

  const handleSaveJudgementAdd = () => {
    const documents = [...props.judgementAddExpertises];
    const currentDocumentStore =
      props.judgementAddDocumentsStore &&
      props.judgementAddDocumentsStore.find(
        item => item.id === documents[props.index]?.id,
      );
    documents[props.index] = formattedJudgementAddPronouncing(
      expertises,
      props.victims,
      props.vehicules,
      props.judgementAddExpertises[props.index],
      currentDocumentStore,
    );

    props.setJudgementAdd(FIELDS_TO_UPDATE.JUDGEMENT_PRONOUNCING, documents);
    props.handleToggleDrawer();
  };

  const [judgementAddDocument, setJudgementAddDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  const setUploadJudgementAddDocument = (document: CorporealDocument) => {
    const judgementAdd = {
      ...props.judgementAddExpertises[props.index],
      ...document,
    };
    handleSetJudgementAddPronouncing(props.index)(judgementAdd);
    setJudgementAddDocument(document);
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate(
        judgementAddMessages.judgementAddPronouncingTitle,
        props,
      )}
      confirmButtonTitle={translate(messages.save, props)}
      handleValidateDrawer={handleSaveJudgementAdd}
      isSaveButtonDisabled={!canSaveJuddgementDocument}
    >
      <JudgementAddFormDrawerStyle>
        <JudgementAddFormFields
          index={props.index}
          handleSetJudgementAddPronouncing={handleSetJudgementAddPronouncing(
            props.index,
          )}
          judgementAddPronouncing={props.judgementAddExpertises[props.index]}
          listings={props.listings}
          details={[]}
          hearingDate={props.hearingDate}
        />
        <section className="expertise-bloc">
          <div className="expertise-title">Expertise</div>
          {!isEmpty(expertises) &&
            expertises.map((expertise, index: number) => (
              <ExpertiseForm
                key={index}
                expertisesListing={get(props.listings, LISTINGS.EXPERTISE, [])}
                victims={props.victims}
                vehicules={props.vehicules}
                expertise={expertise}
                handleSetExpertise={handleSetExpertise(index)}
                index={index}
                canEdit={isEmpty(
                  get(
                    props.judgementAddExpertises[props.index],
                    'expertises',
                    [],
                  ),
                )}
                judgementAddPronouncing={
                  props.judgementAddExpertises[props.index]
                }
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                victimIdsJom={extractVictimIdFromJom(props.judgementOnMerits)}
              />
            ))}
        </section>
        <section>
          <UploadDocumentBloc
            document={judgementAddDocument}
            setDocument={setUploadJudgementAddDocument}
            index={1}
            resetUploadedDocument={props.resetUploadedDocument}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            docType={DOCUMENT_TYPES.JUDGEMENT_ADD}
          />
        </section>
      </JudgementAddFormDrawerStyle>
    </SahamDrawer>
  );
};

export default injectIntl(JudgementAddPronouncingDrawer);
